import '../Styles/Home.css'
import AboutUs from './About';
export function Home(){
    return(
        <div >
            <AboutUs/>
        </div>
    )
}